export const API_URL = 'https://happy-thoughts-api-kolkri.herokuapp.com/thoughts'
export const LIKES_URL =(thoughtId)=> `https://happy-thoughts-api-kolkri.herokuapp.com/thoughts/${thoughtId}/like`

